import { sanitizeNoteHtml } from './AnalystNoteHtml.utilities';

const BLOCK_TAGS = new Set(['p', 'div', 'blockquote', 'pre', 'ul', 'ol']);
const LIST_ITEM_TAG = 'li';
const LINE_BREAK_TAG = 'br';
const IMAGE_TAG = 'img';
const INLINE_IMAGE_PLACEHOLDER = '*image ';

const appendLineBreak = (parts: string[]) => {
  if (parts.length === 0 || parts[parts.length - 1] === '\n') {
    return;
  }

  parts.push('\n');
};

export const getInlineNoteDisplayText = (value?: string | null) => {
  const normalizedValue = value || '';

  if (!normalizedValue || typeof window === 'undefined') {
    return normalizedValue;
  }

  const sanitizedHtml = sanitizeNoteHtml(normalizedValue);
  const parser = new DOMParser();
  const doc = parser.parseFromString(sanitizedHtml, 'text/html');
  const parts: string[] = [];

  const walk = (node: Node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      const text = node.textContent ?? '';
      if (text) {
        parts.push(text);
      }
      return;
    }

    if (node.nodeType !== Node.ELEMENT_NODE) {
      return;
    }

    const element = node as HTMLElement;
    const tagName = element.tagName.toLowerCase();

    if (tagName === IMAGE_TAG) {
      parts.push(INLINE_IMAGE_PLACEHOLDER);
      return;
    }

    if (tagName === LINE_BREAK_TAG) {
      appendLineBreak(parts);
      return;
    }

    if (BLOCK_TAGS.has(tagName)) {
      appendLineBreak(parts);
    }

    if (tagName === LIST_ITEM_TAG) {
      appendLineBreak(parts);
      parts.push('- ');
    }

    Array.from(element.childNodes).forEach(walk);

    if (BLOCK_TAGS.has(tagName) || tagName === LIST_ITEM_TAG) {
      appendLineBreak(parts);
    }
  };

  Array.from(doc.body.childNodes).forEach(walk);

  return parts
    .join('')
    .replace(/\n{3,}/g, '\n\n')
    .replace(/[ \t]+\n/g, '\n')
    .trim();
};
